// Simon AI 功能模块多语言包

export const simonCN = {
  // 欢迎页
  'Simon.WelcomeTitle': '我是 Simon，您的 AI 生物信息学助手',
  'Simon.WelcomeDesc': '解读分析结果、生成可视化图表、探索生物信息学洞见，加速您的研究发现。',

  // 应用描述（卡片长描述）
  'Simon.AppDesc.analyzer': '用自然语言描述分析需求，一键提交并启动分析流程。',
  'Simon.AppDesc.plotter': '根据您的需求生成或定制可视化图表。',
  'Simon.AppDesc.interpreter': '智能解读分析结果，挖掘背后的生物学意义。',

  // 应用名称（中英切换）
  'Simon.AppName.analyzer': '分析',
  'Simon.AppName.plotter': '绘图',
  'Simon.AppName.interpreter': '解读',

  // 工具下拉菜单短描述
  'Simon.AppShortDesc.analyzer': '自然语言提交分析',
  'Simon.AppShortDesc.plotter': '生成或定制图表',
  'Simon.AppShortDesc.interpreter': '智能解读分析结果',

  // 侧栏
  'Simon.Back': '返回',
  'Simon.NewChat': '新对话',
  'Simon.Settings': '设置',
  'Simon.RecentConversations': '最近对话',
  'Simon.Projects': '项目',
  'Simon.Loading': '加载中...',
  'Simon.NoConversationsYet': '暂无对话',
  'Simon.ExpandSidebar': '展开侧栏',
  'Simon.CollapseSidebar': '收起侧栏',
  'Simon.FlatView': '平铺视图',
  'Simon.GroupedView': '分组视图',
  'Simon.More': '更多',

  // 团队选择器
  'Simon.SelectTeam': '选择团队',
  'Simon.SearchTeam': '搜索团队',
  'Simon.NoTeamsFound': '未找到团队',
  'Simon.CurrentTeam': '当前团队',

  // 三点菜单
  'Simon.Rename': '重命名',
  'Simon.Delete': '删除',

  // 弹窗通用
  'Simon.Cancel': '取消',
  'Simon.Confirm': '确定',

  // 删除确认弹窗
  'Simon.DeleteConfirmTitle': '确定删除对话？',
  'Simon.DeleteConfirmDesc': '删除后，聊天记录将不可恢复。',

  // 重命名弹窗
  'Simon.RenameTitle': '编辑对话名称',
  'Simon.RenamePlaceholder': '输入新名称',

  // 语言切换器
  'Simon.Language.En': 'English',
  'Simon.Language.Zh': '中文',

  // Composer 工具栏按钮
  'Simon.SelectTools': '选择工具',
  'Simon.AttachProjectFiles': '选择项目文件',
  'Simon.SelectProject': '选择项目',
  'Simon.UploadFile': '上传文件',

  // Composer 输入框 placeholder（未附加内容时）
  'Simon.Placeholder.analyzer': '请先选择项目，我来帮您提交分析任务。',
  'Simon.Placeholder.plotter': '请先上传绘图文件，我来帮您推荐绘图类型。',
  'Simon.Placeholder.interpreter': '请先关联项目文件，我来帮您解读分析结果。',

  // Composer 附加内容后自动填入的默认文字
  'Simon.AutoFill.analyzer': '请帮我提交一个新的分析任务。',
  'Simon.AutoFill.plotter': '请根据我上传的数据推荐适合的绘图类型。',
  'Simon.AutoFill.interpreter': '请帮我解读这些分析任务的结果。',

  // Attach Project Files 弹窗
  'Simon.SelectProjectFiles': '选择项目文件',
  'Simon.AttachStep1': '选择项目',
  'Simon.AttachStep2': '选择任务',
  'Simon.IntegratedDatasets': '云项目',
  'Simon.CustomDatasets': '本地项目',
  'Simon.JobName': '任务名称',
  'Simon.AnalysisID': '分析ID',
  'Simon.Submitted': '提交时间',
  'Simon.ProjectLocked': '项目已锁定',
  'Simon.CurrentDataset': '当前项目',
  'Simon.DatasetInvalid': '（该项目已失效）',
  'Simon.DatasetInvalidPlaceholder': '该项目已失效，不能继续对话',
  'Simon.Placeholder.Default': '问 Simon 任何问题...',
  'Simon.ThinkingEllipsis': 'Simon 正在思考...',
  'Simon.BackToProject': '返回项目',
  'Simon.SearchByJobOrId': '按任务名称或分析ID搜索...',
  'Simon.SearchByJob': '按任务名称搜索...',
  'Simon.SearchByTask': '按任务名称搜索...',
  'Simon.NoProjectsFound': '未找到项目',
  'Simon.DefaultGroup': '默认',
  'Simon.NoTasksFound': '未找到任务',
  'Simon.Items': '项',
  'Simon.Next': '下一步',

  // 分页
  'Simon.PageSize': '每页',
  'Simon.PerPage': '页',

  // 人工介入
  'Simon.HumanInputResolved': '已{action}',
  'Simon.HumanInputExpired': '该请求已失效，请重新告诉我您的分析需求。',
  'Simon.HumanInputSubmitFailed': '提交失败',
  'Simon.HumanInputPendingPlaceholder': '请先完成上方的待处理操作',
  'Simon.HumanInputFormIncomplete': '请先填写完整表单内容',
  'Simon.HumanInputSelectPlaceholder': '--',
  'Simon.HumanInputInputPlaceholder': '请输入 {name}',
  'Simon.HumanInputOptionsLoadFailed': '选项加载失败，请刷新重试',

  // AI 思考内容区
  'Simon.Thinking': '思考',
  'Simon.ThinkingLoading': 'Simon 正在思考中…',

  // Tips 滚动提示
  'Simon.TipsLabel': 'Tips',
  'Simon.Tips': [
    '关联文件后会自动填入引导指令，按 Enter 即可发送。',
    '新建对话会清空当前上下文，适合换一个新话题。',
    '左侧栏可以按项目分组展示对话，方便回顾历史。',
    '可以从侧边栏点击历史对话，继续之前的讨论。',
    '「绘图」 需要上传文件。',
    '「解读 」用「关联项目文件」按钮添加分析任务。',
    '对话进行中工具按钮会变灰，等回复完成就解锁。',
    '我们在云端运行任务 —— 切换其他任务或关闭页面都没关系，会自动继续。',
    '选好工具后再提问，Simon 会根据场景调整回答方式。',
    '按 Enter 发送，Shift + Enter 换行。',
    '左侧栏展示最近对话和项目分组，快速找到历史记录。',
    '选中多个分析任务，Simon 可以帮您跨任务对比结果。',
    '解读结果支持追问。',
    '想了解某个基因的功能？直接提问，Simon 会结合您的数据上下文。',
    '上传数据后 Simon 会推荐合适的图表类型并帮您生成。',
    '用自然语言描述分析需求，例如「帮我跑一个差异分析」。',
    '提交前 Simon 会帮您确认项目和参数，避免误操作。',
    '同一个项目可以反复提交不同的分析任务。',
  ],
  'Simon.AskSimon': 'Ask Simon',
  'Simon.Differential.Expression.Pre.Question1': '请提交一个差异分析任务',
  'Simon.Differential.Expression.Pre.Question2': '帮我解读这个差异分析的结果',
  'Simon.Differential.Expression.Pre.Question3': '帮我解读这个通路分析的结果',
  'Simon.Cell.Interactions.Pre.Question1': '请提交一个CellPhoneDB细胞互作分析任务',
  'Simon.Cell.Interactions.Pre.Question2': '帮我解读这个CellPhoneDB细胞互作分析的结果',
  'Simon.Cell.Interactions.Pre.Question3': '帮我解读这个CellPhoneDB细胞互作 - 互作对可视化分析的结果',

  "Simon.Drawing.Tools.Pre.Question": '请帮我绘制一个{Tool}图',
  "Simon.Trajectory.Analysis.Pre.Question1": '请提交一个Monocle2分析任务',
  "Simon.Trajectory.Analysis.Pre.Question2": '请提交一个Monocle3分析任务',
  "Simon.Trajectory.Analysis.Pre.Question3": '请提交一个CytoTRACE分析任务',

  "Simon.Trajectory.Analysis.Pre.Question4": '帮我解读这个Monocle2分析的结果',
  "Simon.Trajectory.Analysis.Pre.Question5": '帮我解读这个Monocle2-分支表达情况的结果',
  "Simon.Trajectory.Analysis.Pre.Question6": '帮我解读这个Monocle3分析的结果',
  "Simon.Trajectory.Analysis.Pre.Question7": '帮我解读这个Monocle3-寻找可变基因分析的结果',
  "Simon.Trajectory.Analysis.Pre.Question8": '帮我解读这个CytoTRACE分析的结果',

  'Simon.CNV.Analysis.Pre.Question1': '请提交一个CNV分析任务',
  'Simon.CNV.Analysis.Pre.Question2': '帮我解读这个CNV分析的结果',
  'Simon.ITH.Analysis.Pre.Question1': '请提交一个ITH分析任务',
  'Simon.ITH.Analysis.Pre.Question2': '帮我解读这个ITH分析的结果',
  'Simon.TF.Regulation.Analysis.Pre.Question1': '提交一个pySENIC转录调控分析任务',
  'Simon.TF.Regulation.Analysis.Pre.Question2': '帮我解读这个pySCENIC转录调控分析的结果',
  'Simon.TF.Regulation.Analysis.Pre.Question3': '帮我解读这个pySCENIC转录调控分析 - regulon模块的分析结果',
};

export const simonUS = {
  // Welcome
  'Simon.WelcomeTitle': "I'm Simon, your AI-powered bioinformatics assistant.",
  'Simon.WelcomeDesc': 'Interpret results, generate plots, and explore bioinformatics insights to accelerate your discoveries.',

  // App descriptions
  'Simon.AppDesc.analyzer': 'Describe your analysis needs in natural language and submit analysis jobs in one click.',
  'Simon.AppDesc.plotter': 'Generate or customize plots based on your needs.',
  'Simon.AppDesc.interpreter': 'Intelligently interpret results to uncover biological significance.',

  // App names (CN/EN switching)
  'Simon.AppName.analyzer': 'Analyze',
  'Simon.AppName.plotter': 'Plot',
  'Simon.AppName.interpreter': 'Interpret',

  // Tool dropdown short descriptions
  'Simon.AppShortDesc.analyzer': 'Submit analysis via natural language',
  'Simon.AppShortDesc.plotter': 'Generate or customize plots',
  'Simon.AppShortDesc.interpreter': 'Intelligently interpret results',

  // Sidebar
  'Simon.Back': 'Back',
  'Simon.NewChat': 'New chat',
  'Simon.Settings': 'Settings',
  'Simon.RecentConversations': 'Recent conversations',
  'Simon.Projects': 'Projects',
  'Simon.Loading': 'Loading...',
  'Simon.NoConversationsYet': 'No conversations yet',
  'Simon.ExpandSidebar': 'Expand sidebar',
  'Simon.CollapseSidebar': 'Collapse sidebar',
  'Simon.FlatView': 'Flat view',
  'Simon.GroupedView': 'Grouped view',
  'Simon.More': 'More',

  // Team selector
  'Simon.SelectTeam': 'Select team',
  'Simon.SearchTeam': 'Search team',
  'Simon.NoTeamsFound': 'No teams found',
  'Simon.CurrentTeam': 'Current team',

  // Context menu
  'Simon.Rename': 'Rename',
  'Simon.Delete': 'Delete',

  // Common
  'Simon.Cancel': 'Cancel',
  'Simon.Confirm': 'Confirm',

  // Delete confirm dialog
  'Simon.DeleteConfirmTitle': 'Delete this conversation?',
  'Simon.DeleteConfirmDesc': 'This action cannot be undone.',

  // Rename dialog
  'Simon.RenameTitle': 'Rename conversation',
  'Simon.RenamePlaceholder': 'Enter new name',

  // Language switcher
  'Simon.Language.En': 'English',
  'Simon.Language.Zh': '中文',

  // Composer toolbar buttons
  'Simon.SelectTools': 'Select Tools',
  'Simon.AttachProjectFiles': 'Attach Project Files',
  'Simon.SelectProject': 'Select Project',
  'Simon.UploadFile': 'Upload file',

  // Composer input placeholder (when nothing attached)
  'Simon.Placeholder.analyzer': 'Please select a project first, and I will help submit your analysis task.',
  'Simon.Placeholder.plotter': 'Please upload plot files first, and I will recommend chart types for you.',
  'Simon.Placeholder.interpreter': 'Please attach project files first, and I will help interpret the results.',

  // Composer auto-fill text after attaching content
  'Simon.AutoFill.analyzer': 'Please submit a new analysis task.',
  'Simon.AutoFill.plotter': 'Please recommend suitable chart types.',
  'Simon.AutoFill.interpreter': 'Please interpret these results.',

  // Attach Project Files modal
  'Simon.SelectProjectFiles': 'Select project files',
  'Simon.AttachStep1': 'Select a Project',
  'Simon.AttachStep2': 'Select Tasks',
  'Simon.IntegratedDatasets': 'Integrated datasets',
  'Simon.CustomDatasets': 'Custom datasets',
  'Simon.JobName': 'Job name',
  'Simon.AnalysisID': 'Analysis ID',
  'Simon.Submitted': 'Submitted',
  'Simon.ProjectLocked': 'Project locked',
  'Simon.CurrentDataset': 'Current project',
  'Simon.DatasetInvalid': '(This project is no longer valid)',
  'Simon.DatasetInvalidPlaceholder': 'This project is no longer valid, cannot continue conversation',
  'Simon.Placeholder.Default': 'Ask Simon anything...',
  'Simon.ThinkingEllipsis': 'Simon is thinking...',
  'Simon.BackToProject': 'Back to project',
  'Simon.SearchByJobOrId': 'Search by job name or analysis ID...',
  'Simon.SearchByJob': 'Search by job name...',
  'Simon.SearchByTask': 'Search by task name...',
  'Simon.NoProjectsFound': 'No projects found',
  'Simon.DefaultGroup': 'Default',
  'Simon.NoTasksFound': 'No tasks found',
  'Simon.Items': 'items',
  'Simon.Next': 'Next',

  // Pagination
  'Simon.PageSize': 'Page size',
  'Simon.PerPage': 'per page',

  // Human Input
  'Simon.HumanInputResolved': '{action}',
  'Simon.HumanInputExpired': 'The request has expired. Please tell me your analysis requirement again.',
  'Simon.HumanInputSubmitFailed': 'Submit failed',
  'Simon.HumanInputPendingPlaceholder': 'Please complete the pending action above first',
  'Simon.HumanInputFormIncomplete': 'Please complete the form',
  'Simon.HumanInputSelectPlaceholder': '--',
  'Simon.HumanInputInputPlaceholder': 'Enter {name}',
  'Simon.HumanInputOptionsLoadFailed': 'Failed to load options, please refresh',

  // AI thinking area
  'Simon.Thinking': 'Think',
  'Simon.ThinkingLoading': 'Simon is thinking…',

  // Tips
  'Simon.TipsLabel': 'Tips',
  'Simon.Tips': [
    'Attaching files auto-fills a guided prompt — just press Enter.',
    '"New Chat" clears context — perfect for switching topics.',
    'Conversations could be grouped by project in the sidebar.',
    'Click any past conversation in the sidebar to pick up where you left off.',
    '"Plot" uploads files directly.',
    '"Interpret" uses "Attach Project Files" to add analysis tasks.',
    'The tool button unlocks when conversation done.',
    'We run on cloud machines — feel free to switch tasks or close the page, it\'ll keep working.',
    'Select a tool before asking — the Simon adapts its responses to each scenario.',
    'Press Enter to send, Shift + Enter for new line.',
    'The sidebar shows recent conversations grouped by project for quick access.',
    'Select multiple analysis tasks and the Simon can compare results across them.',
    'Interpretation supports follow-up questions.',
    'Curious about a gene\'s function? Just ask — the Simon will answer in context of your data.',
    'After uploading data, the Simon will recommend suitable chart types and generate them for you.',
    'Describe your analysis in natural language, e.g. "Run a differential analysis for me".',
    'The Simon confirms your project and parameters before submission to avoid mistakes.',
    'Submit multiple different analysis jobs for the same project.',
  ],

  'Simon.AskSimon': 'Ask Simon',
  'Simon.Differential.Expression.Pre.Question1': 'Please submit a differential expression analysis task',
  'Simon.Differential.Expression.Pre.Question2': 'Please interpret this differential expression analysis result.',
  'Simon.Differential.Expression.Pre.Question3': 'Please interpret this pathway analysis result.',
  "Simon.Cell.Interactions.Pre.Question1": "Please submit a CellPhoneDB cell interaction analysis task.",
  "Simon.Cell.Interactions.Pre.Question2": "Please interpret this CellPhoneDB cell–cell interaction analysis result.",
  "Simon.Cell.Interactions.Pre.Question3": "Please interpret this CellPhoneDB cell–interaction pair visualization result.",
  "Simon.Drawing.Tools.Pre.Question": 'Please help me draw a {Tool} plot',
  "Simon.Trajectory.Analysis.Pre.Question1": 'Please submit a Monocle2 analysis task.',
  "Simon.Trajectory.Analysis.Pre.Question2": 'Please submit a Monocle3 analysis task.',
  "Simon.Trajectory.Analysis.Pre.Question3": 'Please submit a CytoTRACE analysis task.',
  "Simon.Trajectory.Analysis.Pre.Question4": 'Please interpret this Monocle2 analysis result.',
  "Simon.Trajectory.Analysis.Pre.Question5": 'Please interpret this Monocle2 - Trajectory state expression result.',
  "Simon.Trajectory.Analysis.Pre.Question6": 'Please interpret this Monocle3 analysis result.',
  "Simon.Trajectory.Analysis.Pre.Question7": 'Please interpret this Monocle3 - Variable gene module expression result.',
  "Simon.Trajectory.Analysis.Pre.Question8": 'Please interpret this CytoTRACE analysis result.',
  "Simon.CNV.Analysis.Pre.Question1": 'Please submit a CNV analysis task.',
  "Simon.CNV.Analysis.Pre.Question2": 'Please interpret this CNV analysis result.',
  "Simon.ITH.Analysis.Pre.Question1": 'Please submit an ITH analysis task.',
  "Simon.ITH.Analysis.Pre.Question2": 'Please interpret this ITH analysis result.',
  "Simon.TF.Regulation.Analysis.Pre.Question1": 'Please submit a pySCENIC transcriptional regulation analysis task.',
  "Simon.TF.Regulation.Analysis.Pre.Question2": 'Please interpret this pySCENIC transcriptional regulation analysis result.',
  "Simon.TF.Regulation.Analysis.Pre.Question3": 'Please interpret this pySCENIC - regulon module identification result.',
};
